import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorInfos} from './error-infos';
import {NotificationToastService} from '../services/notifications/notification-toast.service';
import {ToastErrorModel} from '../models/toasts/toast-error.model';

@Injectable({
  providedIn: 'root'
})
export class Other500ErrorInterceptorService implements HttpInterceptor {

  constructor(private notificationToastService: NotificationToastService) { }

  private static isOther500Error(err: HttpErrorResponse): boolean {
    return err.status == 500 && (err.error == null || err.error['microservice'] == null)
  }

  private extractInfos(err: HttpErrorResponse): Observable<any> {
    return new Observable(observer => {
      if (Other500ErrorInterceptorService.isOther500Error(err)) {
        observer.error(new ErrorInfos('Une erreur est survenue', `${err.message}`))
      } else {
        observer.error(null)
      }
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((erreurBrute: HttpErrorResponse) => {
        return this.extractInfos(erreurBrute).pipe(
          catchError((erreurDecodee: ErrorInfos) => {
            if (erreurDecodee != null) {
              this.notificationToastService.push(new ToastErrorModel(erreurDecodee.content, erreurDecodee.title));
            }
            return throwError(erreurBrute);
          }),
        ) }
      ),
    );
  }
}
